import BaseService from './BaseService'
import store from '@/store'

class OauthService extends BaseService {
  private defaultAxiosInstance
  constructor(baseUrl: string) {
    super(baseUrl)
    this.defaultAxiosInstance = this.axiosInstance
    this.axiosInstance = this.secondaryInstance
  }

  loginWithEmail= (body: { [key: string]: any }, url = 'email') => this.requests.post(`/2/login/${url}`, body)
  forgotPassword = (body:{email:string,companyId?:string}) => this.requests.post(`/users/forgotPassword`, body)
  changePassword = (body:{email:string,newPassword:string,token:string,companyId?:string}) => this.requests.post(`/users/changePassword`, body)
  validateForgotPasswordLink = (email:string,token:string,companyId:string) => this.requests.get(`/users/forgotPassword/validateLink?email=${encodeURIComponent(email)}&token=${token}&companyId=${companyId}`)  
  refreshToken = async (refresh_token: string) => {
    return this.axiosInstance({
      url: `${this.baseUrl}/2/login/token`,
      method: 'POST',
      headers: {...this.headers, 'refresh-token': refresh_token}
    }).then(this.responseBody)
  }
  loginAsProxy = (userId: string) => {
    this.axiosInstance = this.defaultAxiosInstance
    const response = this.requests.post(`/2/login/proxy`, {userId})
    this.axiosInstance = this.secondaryInstance
    return response;
  }
  getCurrentUser = async () => {
    const deviceId = await store.dispatch('getDeviceId')
    this.axiosInstance = this.defaultAxiosInstance
    const response = this.requests.get(`/2/login/current`, {
      headers: {
        'device-id': deviceId
      }
    })
    this.axiosInstance = this.secondaryInstance
    return response;
  }

  async getRebillingConfig(clientId: string, companyId: string, locationId?: string) {
    let url = `/clients/${clientId}/rebilling/${companyId}`

    if (locationId) {
      url += `?locationId=${locationId}`
    }

    this.axiosInstance = this.defaultAxiosInstance
    const response = await this.requests.get(url)
    this.axiosInstance = this.secondaryInstance
    
    return response
  }

  async addRebillingConfig(clientId: string, companyId: string, planId: string, amount: number, locationId?: string) {
    const payload: any = { originalPlan: planId, amount }

    if (locationId) {
      payload.locationId = locationId
    }

    this.axiosInstance = this.defaultAxiosInstance
    const response = await this.requests.post(`/clients/${clientId}/rebilling/${companyId}`, payload)
    this.axiosInstance = this.secondaryInstance

    return response
  }

  async editRebillingConfig(clientId: string, companyId: string, planId: string, amount: number, locationId?: string) {
    const payload: any = { amount }

    if (locationId) {
      payload.locationId = locationId
    }

    this.axiosInstance = this.defaultAxiosInstance
    const response = await this.requests.put(`/clients/${clientId}/rebilling/${companyId}/plan/${planId}`, payload)
    this.axiosInstance = this.secondaryInstance

    return response
  }
}

const instance = new OauthService(BaseService.servicesConfig.Oauth)

export default instance